import React, { useState } from 'react';
import { apiClient } from '../../services/api';
import './TrialExpiredModal.css';

/** Normalize FastAPI error detail — may be a string or a Pydantic validation error array */
const getApiError = (e: any, fallback: string): string => {
  const detail = e?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((d: any) => d?.msg ?? JSON.stringify(d)).join('; ');
  }
  return fallback;
};


const TrialExpiredModal: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleUpgrade = async () => {
        setLoading(true);
        setError('');
        try {
            const res = await apiClient.post('/billing/checkout', {
                success_url: `${window.location.origin}/dashboard`,
                cancel_url: window.location.href,
            });
            if (res.data?.checkout_url) {
                window.location.href = res.data.checkout_url;
            }
        } catch (err: any) {
            setError(getApiError(err, 'Unable to start checkout. Please try again.'));
            setLoading(false);
        }
    };

    return (
        <div className="trial-expired-overlay">
            <div className="trial-expired-modal">
                <div className="trial-expired-icon">⏰</div>
                <h2>Your Free Trial Has Ended</h2>
                <p className="trial-expired-body">
                    Your 14-day free trial has expired. Upgrade to a paid plan to continue using AiMe and retain access to all your content, brands, and campaigns.
                </p>

                <div className="trial-expired-features">
                    <div className="trial-feature">
                        <span className="trial-feature-check">✓</span>
                        <span>All your data is safe — nothing is deleted</span>
                    </div>
                    <div className="trial-feature">
                        <span className="trial-feature-check">✓</span>
                        <span>Resume immediately after upgrading</span>
                    </div>
                    <div className="trial-feature">
                        <span className="trial-feature-check">✓</span>
                        <span>Cancel any time, no lock-in</span>
                    </div>
                </div>

                {error && (
                    <div className="trial-expired-error">{error}</div>
                )}

                <button
                    className="trial-expired-btn"
                    onClick={handleUpgrade}
                    disabled={loading}
                >
                    {loading ? 'Redirecting to checkout…' : 'Upgrade Now'}
                </button>

                <p className="trial-expired-contact">
                    Questions? Contact us at{' '}
                    <a href="mailto:info@clearbyte.au">info@clearbyte.au</a>
                </p>
            </div>
        </div>
    );
};

export default TrialExpiredModal;
